var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-line"},_vm._l((_vm.list),function(item,idx){return _c('div',{key:idx,staticClass:"changeBtn",class:{ active: _vm.value == idx },style:({
      width: (item.width || _vm.width) + 'px',
      height: _vm.height + 'px',
      'margin-right': _vm.margin + 'px',
    }),on:{"click":function($event){return _vm.setValue(idx)}}},[_vm._v(" "+_vm._s(item.name || item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }